"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const errorHandling_1 = require("../../../utils/errorHandling");
function debounceByAction(delay) {
    const source$ = this;
    return new rxjs_1.Observable((observer) => {
        // Using an object as the default value
        // so that the first time we check it
        // if its the same its guaranteed to be false
        // because every object has a different identity.
        // Can't use null or undefined because source may
        // emit these!
        const types = {};
        return source$
            .pipe((0, operators_1.debounce)((value) => {
            if (value && value.type) {
                // If the last value has the same identity we'll
                // actually debounce
                const lastSeen = types[value.type];
                const time = Date.now() - lastSeen;
                if (lastSeen !== undefined && time < delay) {
                    return (0, rxjs_1.merge)((0, rxjs_1.of)({ type: 'CANCEL_SEARCH' }), (0, rxjs_1.timer)(delay));
                }
                else {
                    types[value.type] = Date.now();
                    // This will complete() right away so we don't actually debounce/buffer
                    // it at all
                    return (0, rxjs_1.empty)();
                }
            }
            return (0, rxjs_1.empty)();
        }))
            .subscribe(observer);
    });
}
function getQueryParams(searchOptions, queryParametes, limit) {
    const params = {
        hierarchyType: 'MINIMAL',
        limit: limit
    };
    if (queryParametes) {
        if (queryParametes.markAutomaticOrderFolders) {
            params.markAutomaticOrderFolders =
                queryParametes.markAutomaticOrderFolders;
        }
    }
    if (searchOptions) {
        // params.hideEmpty = searchOptions.toggleHideEmptyFolders || false
        if (searchOptions.hierarchyType) {
            params.hierarchyType = searchOptions.hierarchyType;
        }
        if (searchOptions.toggleShowBookmarks) {
            params.bookmarked = true;
        }
        if (searchOptions.toggleRecents) {
            params.toggleRecents = true;
        }
        if (searchOptions.toggleRecents) {
            params.toggleRecents = true;
        }
        if (searchOptions.searchString) {
            params.sortBy = 'name';
            params.order = 'desc';
        }
        if (searchOptions.from) {
            params.date = searchOptions.from.unix() * 1000;
        }
        if (searchOptions.to) {
            params.dateTo = searchOptions.to.unix() * 1000;
        }
        if (searchOptions.allVersions) {
            params.allVersions = searchOptions.allVersions;
        }
        if (searchOptions.includeSubFolders) {
            params.includeSubFolders = searchOptions.includeSubFolders;
        }
        if (searchOptions.meta &&
            searchOptions.metaValue &&
            searchOptions.metaValue.value) {
            if (searchOptions.metaValue.type === 'day' ||
                searchOptions.metaValue.type === 'datetime') {
                if (searchOptions.metaValue.value &&
                    searchOptions.metaValue.value.start &&
                    searchOptions.metaValue.value.end) {
                    params.meta = searchOptions.meta.id;
                    params.metaValueStart = searchOptions.metaValue.value.start * 1000;
                    params.metaValueEnd = searchOptions.metaValue.value.end * 1000;
                }
            }
            else {
                params.meta = searchOptions.meta.id;
                params.metaValue = `${searchOptions.metaValue.value}`;
            }
        }
        if (searchOptions.searchString ||
            (searchOptions.searchFileType && searchOptions.searchFileType.isSome()) ||
            searchOptions.containsTermString) {
            if (searchOptions.searchString) {
                params.name = searchOptions.searchString;
            }
            if (searchOptions.containsTermString) {
                params.term = searchOptions.containsTermString;
            }
            params.type = searchOptions.searchFileType.fold(undefined, (t) => t === 'ADVANCED_SEARCH' ? undefined : t);
            if (searchOptions.searchString ||
                searchOptions.containsTermString ||
                searchOptions.searchFileType.isSome()) {
                params.search =
                    !!searchOptions.searchString ||
                        !!searchOptions.containsTermString ||
                        searchOptions.searchFileType.isSome();
            }
        }
        if (params.toggleRecents ||
            params.sortBy ||
            params.order ||
            params.meta ||
            params.type) {
            params.includeSubFolders = true;
        }
    }
    return params;
}
function default_1(namespace, useTrottle = true) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function fetch(action$, store, { ajax, getToken, baseUrl }) {
        const handleFetch = (action) => {
            const state = store.value;
            const project = state.project && state.project.currentProject.status === 'FETCHED'
                ? `project/${state.project.currentProject.project.id}`
                : '';
            const obs = action.extra === 'QUICK_SEARCH'
                ? (0, rxjs_1.of)(action).pipe((0, operators_1.delay)(800))
                : (0, rxjs_1.of)(action);
            const searchOptions = action.payload.searchOptions || {};
            const limitSearchToFolder = searchOptions.limitSearchToFolder;
            const params = Object.entries(getQueryParams(searchOptions, action.payload.queryParametes))
                .reduce((acc, [key, value]) => {
                if (value !== undefined) {
                    acc.push(`${key}=${encodeURIComponent(value.toString())}`);
                }
                return acc;
            }, [])
                .join('&');
            return obs.pipe((0, operators_1.mergeMap)(() => ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getToken()
                },
                method: 'GET',
                url: `${baseUrl}api/files/${project}/${limitSearchToFolder && limitSearchToFolder.isSome()
                    ? limitSearchToFolder.toNullable()
                    : action.payload.folderId}?${params}`
            }).pipe((0, operators_1.mergeMap)((data) => _ActionTypes.iFetchSuccessData
                .decode(data.response)
                .fold((e) => (0, rxjs_1.of)(Actions.fetchFailure((0, errorHandling_1.parseValidationError)(e), action.extra)), (res) => (0, rxjs_1.of)(Actions.fetchSuccess(res, action.extra)))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailure((0, errorHandling_1.parseAjaxErrorResponse)(error), action.extra))))));
        };
        if (useTrottle) {
            return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (source$) => debounceByAction.call(source$, 1500), (0, operators_1.switchMap)(handleFetch));
        }
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)(handleFetch));
    }
    return { fetch };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map